export const REQ = {
  section: "my-card-requests-section",
  openBtn: "request-cards-open-btn",
  emptyState: "my-requests-empty",
  row: (id) => `request-row-${id}`,
  statusPill: (id) => `request-status-${id}`,
  form: {
    businessSelect: "req-business-select",
    qty1: "req-qty-1",
    qty2: "req-qty-2",
    qty3: "req-qty-3",
    qty4: "req-qty-4",
    qty5: "req-qty-5",
    qtyMore: "req-qty-more",
    qtyCustomInput: "req-qty-custom-input",
    contactName: "req-contact-name",
    email: "req-email",
    phone: "req-phone",
    shippingAddress: "req-shipping-address",
    notes: "req-notes",
    submitBtn: "req-submit-btn",
    successMessage: "req-success-message",
  },
  summary: {
    active: "my-summary-active",
    requested: "my-summary-requested",
    production: "my-summary-production",
    shipped: "my-summary-shipped",
    delivered: "my-summary-delivered",
  },
};

export const ADMIN = {
  container: "admin-requests-container",
  navLink: "admin-nav-link",
  summary: {
    pending: "admin-summary-pending",
    toOrder: "admin-summary-to-order",
    production: "admin-summary-production",
    shipped: "admin-summary-shipped",
    delivered: "admin-summary-delivered",
  },
  tableRow: (id) => `admin-request-row-${id}`,
  openDetailsBtn: (id) => `admin-request-open-${id}`,
  detailsModal: "admin-request-details",
  statusSelect: "admin-status-select",
  internalNotesInput: "admin-internal-notes",
  saveDetailsBtn: "admin-save-details-btn",
};
